<template>
  <div class="row">

    <PrincipalSection/>
   
    <div  class="col-lg-12 bg-beneficios" id="beneficios">
        <div class="container " v-if="isMobile()">
            <div>
              <h1 class="titulo_beneficio ">Organiza fácil y rápido</h1>
            </div>
        
            <!--<div  data-aos="fade-up" data-aos-duration="1500" class="imagen_beneficios">
                <img src="/static/images/office.png" alt="office">
            </div>-->
            

            <div  class="mt-5">
                <b-row>
                  <b-col sm="12">
                    <div class="d-flex space-between">
                      <h1 class="titulo_opciones">Capital Humano</h1>
                      <b-link block href="#" v-b-toggle.OyP >
                          <span class="when-opened">
                              <b-icon icon="chevron-up" class="chevron"></b-icon>
                          </span>
                          <span class="when-closed">
                              <b-icon icon="chevron-down" class="chevron"></b-icon>
                          </span>
                      </b-link>
                    </div>
                    <b-collapse id="OyP">
                      <p class="texto_opciones">
                        Administra y unifica los procesos internos de talento humano, 
                        llevando el rendimiento de tu equipo al siguiente nivel dentro 
                        de una sola app.  
                      </p>
                    </b-collapse>
                    <hr class="custom-hr1"/>
                  </b-col>
                  <b-col sm="12">
                    <div class="d-flex space-between">
                      <h1 class="titulo_opciones">Servicios para colaboradores</h1>
                      <b-link block href="#" v-b-toggle.SpC >
                          <span class="when-opened">
                              <b-icon icon="chevron-up" class="chevron"></b-icon>
                          </span>
                          <span class="when-closed">
                              <b-icon icon="chevron-down" class="chevron"></b-icon>
                          </span>
                      </b-link>
                    </div>
                    <b-collapse id="SpC">
                      <p class="texto_opciones">
                        Conecta con tus colaboradores mediante perfiles personales en los 
                        que podrás calificar su rendimiento, generar y recibir solicitudes 
                        de permisos, autorizaciones e incidencias. 
                      </p>
                    </b-collapse>
                    <hr class="custom-hr1"/>
                  </b-col>
                  <b-col sm="12">
                    <div class="d-flex space-between">
                      <h1 class="titulo_opciones">Nóminas</h1>
                      <b-link block href="#" v-b-toggle.Nom >
                          <span class="when-opened">
                              <b-icon icon="chevron-up" class="chevron"></b-icon>
                          </span>
                          <span class="when-closed">
                              <b-icon icon="chevron-down" class="chevron"></b-icon>
                          </span>
                      </b-link>
                    </div>
                    <b-collapse id="Nom">
                      <p class="texto_opciones">
                        Calcula y gestiona el proceso de nómina, timbra tus recibos, 
                        descargarlos y genera pólizas contables estándar, 
                        todo con un solo clik desde donde te encuentres.
                      </p>
                    </b-collapse>
                    <hr class="custom-hr1"/>
                  </b-col>
                  <b-col sm="12">
                    <div class="d-flex space-between">
                      <h1 class="titulo_opciones">Asistencias e incidencias</h1>
                      <b-link block href="#" v-b-toggle.Asis >
                          <span class="when-opened">
                              <b-icon icon="chevron-up" class="chevron"></b-icon>
                          </span>
                          <span class="when-closed">
                              <b-icon icon="chevron-down" class="chevron"></b-icon>
                          </span>
                      </b-link>
                    </div>
                    <b-collapse id="Asis">
                      <p class="texto_opciones">
                        Conoce el total de horas laboradas, vacaciones, 
                        retardos o incidencias de cada miembro de tu equipo, 
                        llevando el control de solicitudes y fechas importantes. 
                      </p>
                    </b-collapse>
                    <hr class="custom-hr1"/>
                  </b-col>
                  <b-col sm="12">
                    <div class="d-flex space-between">
                      <h1 class="titulo_opciones">Aplicación Móvil</h1>
                      <b-link block href="#" v-b-toggle.AppM >
                          <span class="when-opened">
                              <b-icon icon="chevron-up" class="chevron"></b-icon>
                          </span>
                          <span class="when-closed">
                              <b-icon icon="chevron-down" class="chevron"></b-icon>
                          </span>
                      </b-link>
                    </div>
                    <b-collapse id="AppM">
                      <p class="texto_opciones">
                        Descubre el poder de la movilidad y digitalización de 
                        tus procesos trabajando desde cualquier lugar, 
                        utilizando navegadores web o sistemas operativos iOS o Android. 
                      </p>
                    </b-collapse>
                    <hr class="custom-hr1"/>
                  </b-col>
                  <b-col sm="12">
                    <div class="d-flex space-between">
                      <h1 class="titulo_opciones">Cliker PREMIUM</h1>
                      <b-link block href="#" v-b-toggle.cPro >
                          <span class="when-opened">
                              <b-icon icon="chevron-up" class="chevron"></b-icon>
                          </span>
                          <span class="when-closed">
                              <b-icon icon="chevron-down" class="chevron"></b-icon>
                          </span>
                      </b-link>
                    </div>
                    <b-collapse id="cPro">
                      <p class="texto_opciones">
                        La solución más completa en gestión de recursos humanos y 
                        administración de nómina para medianas y grandes empresas en México
                        y Latinoamérica.
                      </p>
                    </b-collapse>
                    <hr class="custom-hr1"/>
                  </b-col>
                </b-row>
            </div>

            <div class="col-12">
              <img class="img_opciones" src="static/images/aplicacion.png" alt="office">
            </div>

        </div>
        <div class="container" v-else>
            <div>
              <h1 class="titulo_beneficio">Organiza fácil y rápido</h1>
            </div>
        
        <!--<div data-aos="fade-up" class="imagen_beneficios">
            <img src="/static/images/office.png" alt="office">
        </div>-->

        <div class="mt-5">
            <b-row>
              <b-col data-aos="zoom-in"  data-aos-delay="100" sm="4">
                <img class="img_opciones" src="static/images/capital_humano.png" alt="office" />
                <h1 class="titulo_opciones">Capital Humano</h1>
                <p class="texto_opciones">
                  Administra y unifica los procesos internos de talento humano, 
                  llevando el rendimiento de tu equipo al siguiente nivel dentro 
                  de una sola app.  
                </p>
              </b-col>
              <b-col data-aos="zoom-in" data-aos-delay="300" sm="4">
                <img class="img_opciones" src="static/images/servicios.png" alt="office" />
                <h1 class="titulo_opciones">Servicios para colaboradores</h1>
                <p class="texto_opciones">
                  Conecta con tus colaboradores mediante perfiles personales en los 
                  que podrás calificar su rendimiento, generar y recibir solicitudes 
                  de permisos, autorizaciones e incidencias.
                </p>
              </b-col>
              <b-col data-aos="zoom-in" data-aos-delay="500" sm="4">
                <img class="img_opciones" src="static/images/nominas.png" alt="office" />
                <h1 class="titulo_opciones">Nóminas</h1>
                <p class="texto_opciones">
                  Calcula y gestiona el proceso de nómina, timbra tus recibos, 
                  descargarlos y genera pólizas contables estándar, 
                  todo con un solo clik desde donde te encuentres. 
                </p>
              </b-col>
            </b-row>
        </div>
        
        </div>
    </div>

    <div class="divider-01" v-if="!isMobile()">
    </div>

    <div class="col-lg-12" id="opciones" v-if="!isMobile()">
      <div class="container bg-organiza">
        <div class="">
        <b-row>
          <b-col data-aos="zoom-in" data-aos-delay="100" sm="4">
            <img class="img_opciones" src="static/images/asistencias.png" alt="office" />
            <h1 class="titulo_opciones">Asistencias e incidencias</h1>
            <p class="texto_opciones">
              Conoce el total de horas laboradas, vacaciones, 
              retardos o incidencias de cada miembro de tu equipo, 
              llevando el control de solicitudes y fechas importantes. 
            </p>
          </b-col>
          <b-col data-aos="zoom-in" data-aos-delay="300" sm="4">
            <img class="img_opciones" src="static/images/aplicacion.png" alt="office">
            <h1 class="titulo_opciones">Aplicación Móvil</h1>
            <p class="texto_opciones">
              Descubre el poder de la movilidad y digitalización de 
              tus procesos trabajando desde cualquier lugar, 
              utilizando navegadores web o sistemas operativos iOS o Android. 
            </p>
          </b-col>
          <b-col data-aos="zoom-in" data-aos-delay="500" sm="4">
            <img class="img_opciones" src="static/images/clikerpro.png" alt="office">
            <h1 class="titulo_opciones">Cliker PREMIUM</h1>
            <p class="texto_opciones">
              La solución más completa en gestión de recursos humanos y 
              administración de nómina para medianas y grandes empresas en México
              y Latinoamérica.
            </p>
          </b-col>
        </b-row>
        </div>
      </div>
    </div>

  
    <div class="col-lg-12 bg-beneficios" id="facial" v-if="isMobile()">
      <div class="container bg-organiza">
        <div>
          <h1 class="titulo_facial">Reconocimiento facial</h1>
        </div>

          <p class="text_intro text_facial">
             Verificamos y cuidamos en todo momento los datos personales de cada uno 
             de los usuarios gracias nuestro sistema de reconocimiento facial 
             al momento de acceder a la plataforma.
          </p>
         <hr class="custom-hr2"/>
      </div>
    </div>
    <div class="col-lg-12 bg-beneficios" id="facial" v-else>
      <div class="container bg-organiza">
        <div>
          <h1 class="titulo_facial">Reconocimiento facial</h1>
        </div>
  
        <div class="row">
          <div class="col-10 col-md">
            <p class="text_intro text_facial">
                Verificamos y cuidamos en todo momento los datos personales de cada uno 
                de los usuarios gracias nuestro sistema de reconocimiento facial 
                al momento de acceder a la plataforma.
            </p>
            
              <b-button @click="linkContact()" pill class="btn float-left btn_intro">Solicitar demo</b-button>
          </div>
          <div class="col-2 col-md img_intro">
            <img data-aos="fade-left" data-aos-duration="1000" src="static/images/Facial.png" alt="app_movil">
          </div>
        </div>
      </div>
    </div>

    <div class="divider-01" v-if="!isMobile()">
    </div>

    <Planes/>

    <div class="mid_text col-lg-12">
      <p class="col-lg-12">Haz crecer tu negocio, conoce a detalle el funcionamiento<br>
          y los roles de quienes forman parte de tu equipo. </p>
    </div>

    <div  class="divider-02">
    </div>
    
    <!--<div class="col-lg-12" id="precio">
      <div data-aos="fade-up" class="container bg-organiza" >
        <Precios />
      </div>
    </div>-->

    <div class="col-lg-12 bg-beneficios" id="contacto">
      <div data-aos="fade-up" class="container bg-organiza" >
        <Contacto />
      </div>
    </div>

  </div>
</template>

<script>
import Precios from '@/components/calculadora.vue';
import Contacto from '@/views/Contacto.vue';
import Planes from '@/components/Plans.vue';
import PrincipalSection from '@/components/sections/Principal.vue';
import AOS from 'aos'
import {mapState,mapActions} from "vuex";

export default {
  name: 'Home',
  components: {
    PrincipalSection,
    Precios,
    Contacto,
    Planes
  },
  data() {
    return {
    }
  },
  props: {
    msg: String
  },
  computed: {
   ...mapState("menu",["principal"])
  },
  methods: {
    ...mapActions("menu",["setMenu"]),
    isMobile(){
      var check = false;
      //console.log(window.screen.width);
      if(window.screen.width < 769){
        return check=true;
      }
    },
    refname(refname) {
    	var element = this.$refs[refname];
      //console.log(element);
      var top = element.offsetTop;
      window.scrollTo(0, top);
    },
    aosRefresh(){
    setTimeout(function(){
          AOS.refresh();
          },1000);
    },
    linkContact(){
      setTimeout(function(){
        window.location = "#contacto"; 
        },100);
    },
  },
  mounted () {
    this.aosRefresh();
  },
  created () {
    document.body.scrollTop = 0; // For Safari
    document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera

    this.setMenu(true);
  },
}
</script>

<style scoped>
  
  #intro{
    height: 80vh;
    padding-top: 3%;
    padding-bottom: auto;
  }

  #beneficios{
    padding-top:60px;
  }

  #opciones{
    padding-bottom:60px;
  }

  #facial{
    padding-top:100px;
    padding-bottom:80px;
  }

  #plan{
    padding-top:20px;
    margin-bottom:-160px;
  }

  #precio{
    padding-top:40px;
  }

  .titulo_intro {
    font-family: Muli-Bold;
    font-style: normal;
    font-size: 45px;
    line-height: 55px;
    letter-spacing: 0.2px;

    color: #1E2245;
    text-align: left;
    padding-bottom: 20px;
    padding-top:7%;
  }

  
  
  .img_intro img {
    width: 50%;
  }

   .img_intro_app {
    position:absolute;
    margin-left:38%;
    margin-top:-100px;
    z-index: -1;
  }
  
  .img_intro_app img {
    width: 100%;
  }

  .text_intro{
    font-family: Muli-bold;
    font-style: normal;
    font-size: 30px;
    line-height: 40px;

    text-align: left;
    letter-spacing: 0.2px;
    color: #4F4F4F;
  }

  .btn_intro {
    font-family: Muli-Bold;
    font-style: normal;
    font-size: 14px;
    line-height: 18px;
    letter-spacing: 0.3px;
    background: #2DB9D1;
    border-color: #2DB9D1 !important;
    border-radius: 18px;
    color: #FFFFFF;
    margin-top: 59px;
    padding: 13px 27px;
  }

  .btn_intro:hover {
    color: #FFFFFF;
    background-color: #4F4C4C;
    border-color: #4d4c4f !important;
  }

  .btn_video {
    font-family: Muli-Bold;
    font-style: normal;
    font-size: 14px;
    line-height: 18px;
    letter-spacing: 0.3px;
    background: #FFFFFF;
    border-color: #FFFFFF;
    box-shadow: 0px 3px 10px rgba(0, 0, 0, 0.1);
    border-radius: 100px;
    padding: 13px 27px;
    color: #1E2245;
    margin-top:61vh;
    margin-left: auto;
  }

  .btn_video:hover {
    color: #FFFFFF;
    background-color: #4F4C4C;
    border-color: #4d4c4f !important;
  }


  /* boton subir
  */
  #myBtn {
    display: none;
    position: fixed;
    bottom: 20px;
    right: 30px;
    z-index: 99;
    font-size: 18px;
    border: none;
    outline: none;
    background-color: red;
    color: white;
    cursor: pointer;
    padding: 15px;
    border-radius: 4px;
  }

  #myBtn:hover {
    background-color: #555;
  }

  /**
  * DIVIDERS
  */
  .divider-01 {
    height: 5px;
    width: 8%;
    background-color: #E8404E;
    border-radius: 3px;
    margin: 35px;
    margin-left: auto;
    margin-right: auto;
  }

  .divider-02 {
  height: 5px;
    width: 8%;
    background-color: #8EE8E1;
    border-radius: 3px;
    margin: 35px;
    margin-left: auto;
    margin-right: auto;
  }


  /**Estilo beneficios seccion */
  

  .beneficios {
    padding-top: 100px;
    padding-bottom: 300px;
    background-color: #738AF850;
  }

  .bg-beneficios {
    background: url("/static/images/bg_azul.svg") repeat-x;
  }

  .titulo_beneficio {
    font-family: Muli-Extrabold;
    font-style: normal;
    font-size: 45px;
    line-height: 80px;

    align-items: center;
    text-align: center;
    letter-spacing: 0.2px;
    color: #1E2245;
    
  }

  .imagen_beneficios {
    padding-top: 100px;
    padding-bottom: 50px;
  }

  .imagen_beneficios img {
    width: 80%;
  }

  .titulo_opciones {
    font-family: Muli-Extrabold;
    font-style: normal;
    font-size: 22px;
    line-height: 22px;
    align-items: center;
    text-align: center;
    letter-spacing: 0.2px;

    color: #1E2245;
    padding-bottom: 40px;
  }

  .texto_opciones {
    font-family: Muli-Semibold;
    font-style: normal;
    font-size: 14px;
    line-height: 22px;
    text-align: left;

    letter-spacing: 0.2px;
    color: #4F4F4F;
    padding: 0px 40px;
  }

  .img_opciones {
    width: 60%;
    padding-bottom: 40px;
  }

  .caja_planes .img_opciones {
    padding-bottom: 17%;
  }

  .titulo_facial {
    font-family: Muli-Extrabold;
    font-style: normal;
    font-size: 45px;
    line-height: 80px;

    align-items: center;
    text-align: center;
    letter-spacing: 0.2px;
    color: #1E2245;
    padding-bottom:50px;
  }

  .text_facial {
    padding-top: 40px;

  }

  .planes {
    padding-left: 5%;
    padding-right: 5%;
    padding-top: 40px;
    padding-bottom: 50px;
  }

  .titulo_planes {
    font-family: Muli-Extrabold;
    font-style: normal;
    font-size: 38px;
    line-height: 18px;
    align-items: center;
    text-align: center;
    letter-spacing: 0.2px;
    color: #1E2144;
    margin-top: 40px;
    margin-bottom: 120px;
  }

  .caja_planes{
    background: #FFFFFF;
    box-shadow: 1px 10px 20px rgba(107, 127, 153, 0.2);
    border-radius: 25px;
    margin-bottom:150px;
    padding-top:30px;
  }

  .caja_prime{
    background:#1E2245;
  }

  .plan_titulo {
    font-family: Muli-Extrabold;
    font-style: normal;
    font-size: 26px;
    line-height: 18px;
    align-items: center;
    text-align: center;
    letter-spacing: 0.2px;
    color: #2DB9D1;

    padding-top: 24px;
  }

  .prime_text{
    color: #FFFFFF !important;
  }

  .plan_subtitulo {
    font-family: Muli-Semibold;
    font-style: normal;
    font-size: 18px;
    line-height: 18px;
    align-items: center;
    text-align: center;
    letter-spacing: 0.2px;
    color: #1E2144;
  }

  .btn_plan {
    font-family: Muli-Bold;
    font-style: normal;
    font-size: 14px;
    line-height: 18px;
    background: #1E2144;
    border-radius: 18px;
    letter-spacing: 0.3px;
    border-color: #1E2144 !important;
    color: #FFFFFF;
    padding: 13px 27px;
  }

  .prime_btn {
    background: #2DB9D1;
  }

  .link_plan {
    font-family: Muli-Semibold;
    font-style: normal;
    font-size: 14px;
    line-height: 22px;
    align-items: center;
    letter-spacing: 0.2px;
    color:#1E2245;

    margin-top: 25px;
    display: block;
  }

  .prime_link{
    color:#FFFFFF;
  }

  .mid_text > p{
    font-family: Muli;
    font-style: normal;
    font-weight: 600;
    font-size: 24px;
    line-height: 30px;
    letter-spacing: 0.2px;
    color: #4F4F4F;
  }

  .lista_plan {
    text-align: center;
    margin-left: auto;
    margin-right: auto;
    width: 80%;
    height: 100px;
  }

  .lista_plan > li {
    background: url('/static/images/icons/flecha.png') no-repeat left center;
    font-family: Muli-Semibold;
    font-style: normal;
    font-size: 14px;
    line-height: 22px;
    letter-spacing: 0.2px;
    text-align: left;
    list-style:none;

    padding-left: 25px;
    margin-bottom: 3%;
    color: #1E2144;
  }

  .prime_text > li{
    background: url('/static/images/icons/flecha_white.png') no-repeat left center;
    color:#FFFFFF;
  }

  .lista_plan > li > span {
    color: #2DB9D1;
  }

  .no_aplica {
    background: url('/static/images/icons/tache.png') no-repeat left center !important;
    padding-left: 25px;
    color: #BDBDBD !important;
  }

   .lista_plan_completo {
    text-align: center;
    margin-left: auto;
    margin-right: auto;
    width: 80%;
    margin-top:100px;
    margin-bottom:100px;
  }

  .lista_plan_completo > li {
    font-family: Muli;
    font-style: normal;
    font-size: 14px;
    font-weight: bold;
    line-height: 22px;
    letter-spacing: 0.2px;
    text-align: left;
    list-style:none;
    margin-bottom: 20px;
    color: #1E2144;
  }

  .prime_lpc > li{
    color:#FFFFFF;
  }

  .prime_lpc > li > ul > li{
    color:#FFFFFF !important;
    background: url('/static/images/icons/flecha_white.png') no-repeat left 5px !important;
  }


  .lista_plan_completo > li > ul {
   padding-left:0px;
   margin-top:15px;
  }

  .lista_plan_completo > li > ul > li {
    background: url('/static/images/icons/paloma_gris.png') no-repeat left 5px;
    font-family: Muli;
    font-style: normal;
    font-size: 12px;
    line-height: 18px;
    letter-spacing: 0.2px;
    text-align: left;
    list-style:none;
    padding-left: 25px;
    color: #828282;
    margin-bottom:5px;
  }

  .no_aplica_completo {
    color: #BDBDBD !important;
  }

  .no_aplica_completo > ul > li {
    background: url('/static/images/icons/tache.png') no-repeat left center !important;
    font-family: Muli;
    font-style: normal;
    font-weight: 600;
    font-size: 12px;
    line-height: 22px;
    letter-spacing: 0.2px;
    text-align: left;
    list-style:none;
    padding-left: 25px;
    color: #BDBDBD !important;
  }

  .no_aplica_li{
    background: url('/static/images/icons/tache.png') no-repeat left center !important;
    font-family: Muli;
    font-style: normal;
    font-weight: 600;
    font-size: 12px;
    line-height: 22px;
    letter-spacing: 0.2px;
    text-align: left;
    list-style:none;
    padding-left: 25px;
    color: #BDBDBD !important;
  }

  /**Estilos de chat */
  .card-body {
    flex: 1 1 auto;
    min-height: 1px;
    width: 340px;
    height: 572px;
    left: 149px;
    background: #FFFFFF;
    box-shadow: 1px 10px 20px rgba(107, 127, 153, 0.1);
    border-radius: 10px;
  }

  .card-title {
    height: 5.0625rem;
    background: #3C64B1;
    border-radius: 10px 10px 0px 0px;
    padding-top: 1em;
    color: #FFF;
  }
  .collapsed > .when-opened,
      :not(.collapsed) > .when-closed {
          display: none;
      }

  @media(min-width: 1500px){
     #intro{
      height: 85vh;
      padding-top: 5%;
      padding-bottom: auto;
    }

    .img_intro_app{
      padding-top:100px;
    }
    .titulo_intro{
      padding-top:130px;
    }
    .btn_video{
      margin-top:58vh;
    }
   
  }

  @media(max-width: 768px){
    #intro{
      margin-top:0px;
      padding-top:0px;
      height: 100%;
    }

    #beneficios{
      padding-top:0px;
    }

    #opciones{
      padding-bottom:0px;
    }

    #facial{
      padding-top:0px;
      padding-bottom:0px;
    }

    #plan{
      padding-top:0px;
      margin-right: 0px;
      margin-left: 0px;
      margin-bottom:0px;
    }
    .prime_content{
      padding:15px;
    }

    .caja_prime{
      background: #1E2245;
    }

    .mid_text > p{
      margin-bottom:80px;
    }

    #precio{
      padding-top:0px;
    }

    .titulo_intro {
      font-size: 32px;
      line-height: 40px;
    }

    .text_intro{
      font-size: 14px;
      line-height: 25px;
    }

    .btn_intro {
      width: 100%; 
      margin-bottom: 25px;
      padding-bottom: 13px;
      padding-top:13px;
      border-radius: 14px;
    }

    .titulo_beneficio {
      padding-top: 20px;
      font-size: 26px;
      line-height:0px;
      color: #1E2245;
      
    }
    
    .bg-beneficios {
      background: url("/static/images/bg_azul.svg") repeat-x;
      background-size: 414px;
    }

    .imagen_beneficios {
      padding-top: 50px;
    }

    .imagen_beneficios img{
      width: 100%;
    }

    .titulo_opciones {
      font-size: 16px;
      line-height: 0px;
      letter-spacing: 0.06px;
      align-items: left;
      text-align: left;
      color: #1E2245;
      padding-bottom: 0px;
      padding-top: 10px;
    }

    .texto_opciones {
      font-size: 12px;
      line-height: 14px;
      text-align: left;
      padding:0px;
      padding-top: 10px;
      letter-spacing: 0.06px;
      width: 90%;
      color: #4F4F4F;
    }

    .img_opciones {
        width: 60%;
        padding-top: 20px;
        padding-bottom: 0px;
        margin-bottom: -45px;
      }

    .chevron{
      color:#2DB9D1;
      font-size: 16px;
      }  

    .collapsed > .when-opened,
      :not(.collapsed) > .when-closed {
          display: none;
      }

    .titulo_facial {
       padding-top: 20px;
      font-size: 26px;
      line-height:0px;
      color: #1E2245;
      }

    .text_facial {
      padding-top: 40px;
      text-align: center;
      font-style: normal;
      font-weight: 600;
      line-height: 14px;
      letter-spacing: 0.06px;
      font-size: 12px;
      padding-bottom:0px;
      }

      .custom-hr1{

      }

      .custom-hr2{
        margin-left: -2%;
        margin-right: -2%;
        border: 0.5px solid #3C64B1;
      }

      .titulo_planes {
        font-size: 26px;
        line-height: 32px;
        letter-spacing: 0.2px;
        color: #1E2144;
        margin-top: -50px;
        margin-bottom: 30px;
      }

      .btn_plan {
        width: 100%; 
      padding-bottom: 13px;
      padding-top:13px;
      border-radius: 14px;
      }

      
      .lista_plan {
        padding-top: 50px;
        text-align: left;
        margin-left: auto;
        margin-right: auto;
        width: 100%;
        height: 160px;
      }

      .lista_plan > li {
        background: url('/static/images/icons/flecha.png') no-repeat left center;
        height: 20px;
        font-family: Muli-Semibold;
        font-style: normal;
        font-size: 14px;
        line-height: 22px;
        letter-spacing: 0.2px;
        text-align: left;
        list-style:none;

        padding-left: 25px;
        margin-bottom: 5%;
        color: #1E2144;
      }

      .prime_text > li{
    background: url('/static/images/icons/flecha_white.png') no-repeat left center;
    color:#FFFFFF;
  }

      .lista_plan_completo {
        text-align: left;
        margin-left: auto;
        margin-right: auto;
        padding:auto;
        width: 100%;
        margin-top:100px;
      }

      .lista_plan_completo > li {
        font-family: Muli;
        font-style: normal;
        font-size: 14px;
        font-weight: bold;
        line-height: 22px;
        letter-spacing: 0.2px;
        text-align: left;
        list-style:none;
        margin-bottom: 20px;
        color: #1E2144;
      }

      .prime_lpc > li{
        color:#FFFFFF;
      }
      .prime_lpc > li > ul > li{
        color:#FFFFFF !important;
        background: url('/static/images/icons/flecha_white.png') no-repeat left 5px !important;
      }

  .lista_plan_completo > li > ul {
   padding-left:0px;
   margin-top:15px;
  }

  .lista_plan_completo > li > ul > li {
    background: url('/static/images/icons/paloma_gris.png') no-repeat left 5px;
    font-family: Muli;
    font-style: normal;
    font-size: 12px;
    line-height: 18px;
    letter-spacing: 0.2px;
    text-align: left;
    list-style:none;
    padding-left: 25px;
    color: #828282;
    margin-bottom:5px;
  }


      .divider-02 {
        height: 5px;
        width: 120px;
        background-color: #8EE8E1;
        border-radius: 3px;
        margin-top: -10px;
        margin-left: auto;
        margin-right: auto;
      }

  }

  @media only screen and(max-width: 30%) {
    #demo {
      display: none;
    }
  }
</style>
